<template>
  <div>
    <h2 class="do-h2">
      INICIAR SESIÓN
    </h2>
    <p class="do-p">
      Ingresa tu correo electrónico y contraseña
      para comenzar
    </p>
    <div class="box">
      <form
        class="needs-validation"
        novalidate
        @submit.prevent="onSubmitData"
      >
        <div class="form-group">
          <label for="letsbegin-email">Correo Electrónico:</label>
          <input
            id="letsbegin-email"
            v-model="email"
            type="email"
            name="letsbegin-email"
            class="form-control"
            required
          >
          <div class="invalid-feedback">
            Asegúrate de escribir bien tu correo.
          </div>
        </div>
        <div class="form-group">
          <label for="letsbegin-password">Contraseña</label>
          <input
            id="letsbegin-password"
            ref="password"
            v-model="password"
            type="password"
            name="letsbegin-password"
            class="form-control"
            required
          >
          <div class="invalid-feedback">
            {{ passwordValidationMessage }}
          </div>


          <p class="form-text mt-2">
            <small><a
              href=""
              @click.prevent="$router.push({ name: 'password_reset' })"
            >¿Olvidaste la contraseña?</a></small>
            |
            <small>
              ¿No tiene una cuenta?, <a
                href=""
                @click.prevent="registerDialog()"
              >Regístrate</a></small>
          </p>
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-block"
          :disabled="submitButtonDisabled"
        >
          INICIAR SESIÓN
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import store from '../../_store';

export default {
    name: 'LetsBegin',
    data() {
        return {
            email: '',
            password: '',
            passwordValidationMessage: '',

            submitButtonDisabled: false,
        };
    },
    methods: {
        ...mapMutations('loginDialog', ['setCurrentDialog']),
        ...mapActions('loginDialog', ['setDialogWithProps', 'setNextDialog']),
        performLogin() {
            return store.dispatch('authentication/login', {
                username: this.email,
                password: this.password,
            })
                .then(this.setNextDialog)
                .catch((err) => {
                    if (err.response.status === 400 && (
                        err.response.data.non_field_errors || err.response.data.password
                    )) {
                        this.passwordValidationMessage = 'El correo o contraseña están incorrectos. Intenta de nuevo.';
                        this.$refs.password.setCustomValidity(this.passwordValidationMessage);
                    }
                    throw err;
                });
        },
        checkValidity(e) {
            return new Promise((resolve, reject) => {
                if (e.target.checkValidity()) resolve(); else {
                    reject(new Error('One or more form fields do not contain valid data'));
                }
            });
        },
        setButtonDisabled(disabledStatus) {
            return new Promise((resolve) => {
                this.submitButtonDisabled = (typeof disabledStatus !== 'undefined')
                    ? !!disabledStatus : !this.submitButtonDisabled;
                resolve();
            });
        },
        onSubmitData(e) {
            this.$refs.password.setCustomValidity('');
            this.checkValidity(e)
                .then(() => this.setButtonDisabled(true))
                .then(this.performLogin)
                .catch((err) => {
                    e.stopPropagation();
                    throw new Error(`Problem with handling something: ${err}`);
                })
                .finally(() => {
                    e.target.classList.add('was-validated');
                    this.setButtonDisabled(false);
                });
        },
        registerDialog() {
            this.setCurrentDialog('StudentRegister');
        },
    },
};
</script>
